const configPath = 'awbconfig.json';
export default configPath;
